import { PHASE } from "../../../common/constants.ts";
import { useLocal } from "../../util/local.ts";

// Phase 8a: the sim runner broadcasts each simulated day's scores; this shows
// them live so everyone can watch a synced sim in progress. Ephemeral - it
// disappears when the segment finishes and the authoritative snapshot loads.
const MpLiveScores = () => {
	const { mpLiveScores, userTid } = useLocal(["mpLiveScores", "userTid"]);

	if (!mpLiveScores || mpLiveScores.games.length === 0) {
		return null;
	}

	return (
		<div className="card mb-3 border-danger" style={{ maxWidth: 720 }}>
			<div className="card-body">
				<h2 className="card-title d-flex align-items-center gap-2">
					<span className="badge text-bg-danger">● LIVE</span>
					<span>
						{mpLiveScores.phase === PHASE.PLAYOFFS
							? "Playoffs"
							: "Regular season"}
					</span>
					<span className="text-body-secondary fs-6 fw-normal ms-auto">
						{mpLiveScores.totalSimmed}{" "}
						{mpLiveScores.totalSimmed === 1 ? "game" : "games"} simulated
					</span>
				</h2>
				<p className="text-body-secondary">
					The sim runner is playing out games - scores update live. Final
					results load when the segment finishes.
				</p>
				<div className="d-flex flex-wrap gap-2">
					{mpLiveScores.games.map((gm) => {
						const [t0, t1] = gm.teams;
						const mine = t0.tid === userTid || t1.tid === userTid;
						const t0Won = t0.pts > t1.pts;
						return (
							<div
								key={gm.gid}
								className={`border rounded px-3 py-2${mine ? " border-primary border-2" : ""}`}
								style={{ minWidth: 120 }}
							>
								<div
									className={`d-flex justify-content-between gap-3${t0Won ? " fw-bold" : " text-body-secondary"}`}
								>
									<span>{t0.abbrev}</span>
									<span>{t0.pts}</span>
								</div>
								<div
									className={`d-flex justify-content-between gap-3${!t0Won ? " fw-bold" : " text-body-secondary"}`}
								>
									<span>{t1.abbrev}</span>
									<span>{t1.pts}</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default MpLiveScores;
